import { createStyles, makeStyles } from '@material-ui/core';
import { fillBlue } from '../../utils/contrastSvgAttributes';

export const useStyles = makeStyles(() =>
  createStyles({
    actionIcon: {
      top: '1px',
      color: fillBlue,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(202, 202, 252, 0.37)',
        borderRadius: '100%',
      },
    },
    hoover: {
      '&:hover': {
        backgroundColor: 'rgba(202, 202, 252, 0.37)',
        borderRadius: '100%',
        cursor: 'pointer',
      },
    },
    dropdownMenu: {
      '& .MuiMenuItem-root': {
        color: '#2C2D3E',
        fontSize: '14px',
        '&:hover': {
          backgroundColor: 'rgba(202, 202, 252, 0.2)',
          color: '#3C419A',
          '& svg':{
            fill: '#3C419A'
          }
        },
      },
    },
  }),
);
